import React from "react";
import styled, { css } from "styled-components";
import useRightSidebar from "hooks/useRightSidebar";
const StyledButton = styled.button(
  ({ theme }) => css`
    background: none;
    border: none;
    padding: 0;
    color: ${theme.colors.variant.primary};
    cursor: pointer;
    font-size: inherit;
    font-family: inherit;

    :hover {
      color: ${theme.colors.variant.dark.primary};
    }

    :focus-visible {
      outline: 2px solid ${theme.colors.variant.primary};
      outline-offset: 2px;
      border-radius: 2px;
    }

    :active {
      color: ${theme.colors.variant.darker.primary};
    }
  `
);
const SidebarNavigationLink = ({ content, children }) => {
  const { openSidebar } = useRightSidebar();
  const handleClick = () => {
    openSidebar(content);
  };
  return /* @__PURE__ */ React.createElement(StyledButton, { type: "button", onClick: handleClick }, children);
};
export default SidebarNavigationLink;
